function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9001 2.51013C18.791 2.12528 18.5848 1.77502 18.301 1.49304C18.0173 1.21106 17.6655 1.00675 17.28 0.900021C14.8679 0.610092 12.4393 0.479916 10.01 0.510128C7.58073 0.479916 5.15209 0.610092 2.73999 0.900021C2.35447 1.00675 2.00321 1.21106 1.71948 1.49304C1.43575 1.77502 1.22947 2.12528 1.12036 2.51013C0.847519 3.99444 0.713216 5.50096 0.719969 7.01013C0.71777 8.50916 0.852043 10.0053 1.12036 11.4801C1.22709 11.8672 1.4321 12.2201 1.71606 12.504C2.00003 12.788 2.35284 12.9935 2.73999 13.1002C5.15209 13.3901 7.58073 13.5203 10.01 13.4901C12.4391 13.5103 14.8671 13.3802 17.28 13.1002C17.6655 12.9935 18.0173 12.7892 18.301 12.5072C18.5848 12.2252 18.791 11.875 18.9001 11.4901C19.1697 10.0122 19.3004 8.51236 19.2903 7.01013C19.3008 5.50457 19.1701 4.00134 18.9001 2.52014V2.51013ZM8.15015 9.79016V4.22009L13.0002 7.01013L8.15015 9.79016Z",
  fill: "currentColor"
});

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8636511f.svg";
export { ForwardRef as ReactComponent };